import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { Translate, ICrudGetAllAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './job-order-owner.reducer';
import { IJobOrderOwner } from 'app/shared/model/job-order-owner.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IJobOrderOwnerProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const JobOrderOwner = (props: IJobOrderOwnerProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { jobOrderOwnerList, match, loading } = props;
  return (
    <div>
      <h2 id="job-order-owner-heading">
        <Translate contentKey="ordersManagementApp.jobOrderOwner.home.title">Job Order Owners</Translate>
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp;
          <Translate contentKey="ordersManagementApp.jobOrderOwner.home.createLabel">Create new Job Order Owner</Translate>
        </Link>
      </h2>
      <div className="table-responsive">
        {jobOrderOwnerList && jobOrderOwnerList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="global.field.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.jobOrderOwner.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.jobOrderOwner.surname">Surname</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.jobOrderOwner.user">User</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.jobOrderOwner.businessUnit">Business Unit</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {jobOrderOwnerList.map((jobOrderOwner, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${jobOrderOwner.id}`} color="link" size="sm">
                      {jobOrderOwner.id}
                    </Button>
                  </td>
                  <td>{jobOrderOwner.name}</td>
                  <td>{jobOrderOwner.surname}</td>
                  <td>{jobOrderOwner.user ? jobOrderOwner.user.id : ''}</td>
                  <td>
                    {jobOrderOwner.businessUnit ? (
                      <Link to={`business-unit/${jobOrderOwner.businessUnit.id}`}>{jobOrderOwner.businessUnit.businessUnitName}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${jobOrderOwner.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${jobOrderOwner.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${jobOrderOwner.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="ordersManagementApp.jobOrderOwner.home.notFound">No Job Order Owners found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ jobOrderOwner }: IRootState) => ({
  jobOrderOwnerList: jobOrderOwner.entities,
  loading: jobOrderOwner.loading
});

const mapDispatchToProps = {
  getEntities
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(JobOrderOwner);
